document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-mobile-menu]');
const siteHeader = document.querySelector('.site-header');

if (menuButton && menu) {
  const menuClose = menu.querySelector('[data-menu-close]');

  // Cale le panneau juste sous le header réel (bandeau + header), quels que soient
  // l'appareil et la position de scroll. Évite le « top: 114px » codé en dur.
  const setHeaderOffset = () => {
    const offset = siteHeader ? siteHeader.getBoundingClientRect().bottom : 0;
    document.documentElement.style.setProperty('--header-h', Math.max(0, Math.round(offset)) + 'px');
  };

  const isMenuOpen = () => menu.classList.contains('is-open');

  const openMenu = () => {
    setHeaderOffset();
    menu.classList.add('is-open');
    menuButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
  };

  const closeMenu = () => {
    menu.classList.remove('is-open');
    menuButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  };

  // Toggle robuste : preventDefault + stopPropagation pour neutraliser le double
  // touch/click ET empêcher que ce même clic remonte jusqu'au handler « tap dehors »
  // (sinon le menu se rouvrirait/refermerait aussitôt → effet flash).
  menuButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isMenuOpen()) closeMenu();
    else openMenu();
  });

  // Bouton FERMER (✕)
  menuClose?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    closeMenu();
  });

  // Fermeture au tap sur un lien du menu (la navigation suit normalement).
  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => closeMenu());
  });

  // Fermeture au tap en dehors. Le tap d'ouverture ne se propage pas jusqu'ici
  // (stopPropagation ci-dessus), et on ignore tout clic sur le menu ou le bouton.
  document.addEventListener('click', (event) => {
    if (!isMenuOpen()) return;
    if (menu.contains(event.target) || menuButton.contains(event.target)) return;
    closeMenu();
  });

  // Échap ferme le menu (accessibilité clavier).
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isMenuOpen()) closeMenu();
  });

  // Rotation / redimensionnement : recale le panneau, et referme proprement si on
  // repasse en layout desktop (évite de laisser body en overflow:hidden).
  window.addEventListener('resize', () => {
    if (!isMenuOpen()) return;
    if (window.matchMedia('(min-width: 991px)').matches) closeMenu();
    else setHeaderOffset();
  });
}

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const variantSelect = form.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  const button = form.querySelector('[data-add-button]');

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (price && option.dataset.price) {
        const now = '<span class="price__now">' + option.dataset.price + '</span>';
        const was = option.dataset.comparePrice
          ? ' <s class="price__was">' + option.dataset.comparePrice + '</s>'
          : '';
        price.innerHTML = now + was;
        price.classList.toggle('price--sale', Boolean(option.dataset.comparePrice));
      }
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
      const stockAlert = form.querySelector('[data-stock-alert]');
      if (stockAlert) {
        const tracked = option.dataset.tracked;
        const inv = parseInt(option.dataset.inventory, 10);
        const threshold = parseInt(stockAlert.dataset.threshold, 10);
        const available = option.dataset.available === 'true';
        if (tracked && available && inv > 0 && inv <= threshold) {
          const count = stockAlert.querySelector('[data-stock-count]');
          if (count) count.textContent = inv;
          stockAlert.hidden = false;
        } else {
          stockAlert.hidden = true;
        }
      }
    });
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[data-add-button]');
    if (!button || button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Ajout…';

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Cart request failed');
      const item = await response.json();
      const count = document.querySelector('[data-cart-count]');
      if (count) {
        const current = Number.parseInt(count.textContent, 10) || 0;
        count.textContent = current + item.quantity;
      }

      const toast = document.querySelector('[data-cart-toast]');
      if (toast) {
        toast.classList.add('is-visible');
        window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
      }
      button.textContent = 'C’est dans le panier';
      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1500);
    } catch (error) {
      form.submit();
    }
  });
});

document.querySelectorAll('[data-quick-add]').forEach((button) => {
  button.addEventListener('click', async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.disabled = true;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Quick add request failed');

      const count = document.querySelector('[data-cart-count]');
      if (count) count.textContent = (Number.parseInt(count.textContent, 10) || 0) + 1;
      button.textContent = '✓';
      const toast = document.querySelector('[data-cart-toast]');
      if (toast) {
        toast.classList.add('is-visible');
        window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
      }
    } catch (error) {
      window.location.href = button.dataset.productUrl;
    } finally {
      window.setTimeout(() => {
        button.textContent = '+';
        button.disabled = false;
      }, 1400);
    }
  });
});

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim()) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

// Filter sidebar drawer (collection page)
const filterSidebar = document.getElementById('FilterSidebar');
const filterOverlay = document.querySelector('[data-filter-overlay]');
const openFilterBtn = document.querySelector('[data-open-filter]');
const closeFilterBtn = document.querySelector('[data-close-filter]');

function openFilter() {
  filterSidebar?.classList.add('is-open');
  filterOverlay?.classList.add('is-visible');
  openFilterBtn?.setAttribute('aria-expanded', 'true');
  document.body.classList.add('menu-open');
}

function closeFilter() {
  filterSidebar?.classList.remove('is-open');
  filterOverlay?.classList.remove('is-visible');
  openFilterBtn?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
}

if (filterSidebar) {
  openFilterBtn?.addEventListener('click', openFilter);
  closeFilterBtn?.addEventListener('click', closeFilter);
  filterOverlay?.addEventListener('click', closeFilter);
}

// Fade-in des cartes au scroll (léger, sans jank)
(function revealCards() {
  const cards = document.querySelectorAll('.product-card');
  if (!cards.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    cards.forEach((card) => card.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  cards.forEach((card) => observer.observe(card));
})();

// Accordéons (fiche produit)
document.querySelectorAll('[data-accordion-toggle]').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const accordion = toggle.closest('[data-accordion]');
    if (!accordion) return;
    const isOpen = accordion.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
});
